import { branch, buildSteps, split, stepTemplate } from "@airhelp/funnel";
import { ItineraryDetailsStep } from "../steps/ItineraryDetails";
import { MultilegDisruptedFlightStep } from "../steps/MultilegDisruptedFlight";
import { TripDetailsStep } from "../steps/TripDetails";
import {
  getPreEligibilityDataSnapshot,
  PreEligibilityDataSnapshot,
} from "../state/preEligibilityState";
import { DelayInformationStep } from "../steps/DelayInformation";
import { ReactRouterFunnelDefinition } from "@airhelp/funnel/react-router";
import { FlightSelectorStep } from "../steps/FlightSelector";
import { DisruptedFlightDetectedStep } from "../steps/DisruptedFlightDetected";

const multilegDisruptedFlightStep = stepTemplate<PreEligibilityDataSnapshot>({
  name: "multileg-disrupted-flight",
  uri: "multileg-disrupted-flight",
  Component: MultilegDisruptedFlightStep,
});

const tripDetailsStep = stepTemplate<PreEligibilityDataSnapshot>({
  name: "trip-details",
  uri: "trip-details",
  Component: TripDetailsStep,
});

const itineraryDetailsStep = stepTemplate<PreEligibilityDataSnapshot>({
  name: "itinerary-details",
  uri: "itinerary-details",
  Component: ItineraryDetailsStep,
});

const delayInformationStep = stepTemplate<PreEligibilityDataSnapshot>({
  name: "delay-information",
  uri: "delay-information",
  Component: DelayInformationStep,
  meta: {
    claimShouldBeSubmitted: true,
  },
});

const flightSelectorStep = stepTemplate<PreEligibilityDataSnapshot>({
  name: "flight-selector-date",
  uri: "flight-selector-date",
  Component: FlightSelectorStep,
});

const disruptedFlightDetectedStep = stepTemplate<PreEligibilityDataSnapshot>({
  name: "disrupted-flight-detected",
  uri: "disrupted-flight-detected",
  Component: DisruptedFlightDetectedStep,
});

const singleLegFlow = () =>
  branch(
    [
      flightSelectorStep(),
      disruptedFlightDetectedStep({
        enabled: ({ state }) =>
          state.claimDetails.potentialClaimType === "delayed" ||
          state.claimDetails.potentialClaimType === "cancelled",
      }),
      delayInformationStep(),
    ],
    ({ state }) => !state.flightDetails.anyConnections,
  );

const multilegFlow = () =>
  branch(
    [multilegDisruptedFlightStep(), itineraryDetailsStep(), delayInformationStep()],
    ({ state }) => state.flightDetails.anyConnections,
  );

export const preEligibilityDesktopFunnelDefinition: ReactRouterFunnelDefinition<PreEligibilityDataSnapshot> =
  {
    basePath: `/claims/new/`,
    steps: buildSteps([tripDetailsStep(), split([singleLegFlow(), multilegFlow()])]),
    getState: () => getPreEligibilityDataSnapshot(),
  };
